import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import EstimateModeHeader from './EstimateModeHeader';
import setOrigin from '../../actions/setOrigin';

const mapStateToProps = (props) => {
  const { originReducer } = props;
  const originMODE = originReducer.mode;
  window.localStorage.setItem('originMode', originMODE);

  return {
    originMODE,
  };
};

const mapDispatchToProps = (dispatch) => {
  const actions = bindActionCreators(
    {
      setOrigin,
    },
    dispatch,
  );

  return { ...actions, dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps)(EstimateModeHeader);
